import { render, staticRenderFns } from "./ElibroIndex.vue?vue&type=template&id=b1a56e4c&scoped=true"
import script from "./ElibroIndex.vue?vue&type=script&lang=js"
export * from "./ElibroIndex.vue?vue&type=script&lang=js"
import style0 from "./ElibroIndex.vue?vue&type=style&index=0&id=b1a56e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a56e4c",
  null
  
)

export default component.exports